import { createQs, deleteQ, updateQ } from "../../utils/api";
import { add_hand } from "../../utils/utils";

export default function QFormat({ q, state, id }: Component) {
  let [inputValues, setInputValues] = state;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, Q: string) => {
    let b = document.getElementById(`btn-update-${Q}`) as HTMLElement;
    b.style.display = "block";
    setInputValues((prevValues: any) => ({
      ...prevValues,
      [Q]: e.target.value,
    }));
  };

  return (
    <>
      {q.map((Q: string) => (
        <form
          key={Q}
          id={"form-" + Q}
          className="input-group mb-3"
          onSubmit={(e) => updateQ(id, Q, inputValues[Q])}
        >
          <input
            value={inputValues[Q]}
            id={"input-" + Q}
            className="form-control"
            onChange={(e) => handleChange(e, Q)}
          />
          <button
            type="submit"
            className="btn btn-primary"
            id={"btn-update-" + Q}
            style={{ display: "none" }}
          >
            Update
          </button>
          <button
            className="btn btn-danger"
            onClick={(e) => {
              e.preventDefault();
              deleteQ(id, Q);
              document.getElementById(`input-${Q}`)?.remove();
              delete inputValues[Q];
              setInputValues(inputValues);
            }}
          >
            Delete
          </button>
        </form>
      ))}
      <button className="btn btn-primary" onClick={add_hand}>
        add Qs
      </button>
      <form
        id="add-form"
        onSubmit={(e) => {
          e.preventDefault();
          let ee: string[] = [];
          document
            .querySelectorAll("#input-add-q")
            .forEach((e: any) => ee.push(e.value));
          createQs(id, ee).then(console.log);
          ee.forEach((eq) => setInputValues({ [eq]: eq, ...inputValues }));
        }}
        style={{ display: "none" }}
      >
        <input type="submit" className="btn btn-primary" value="Submit" />
      </form>
    </>
  );
};

type Component = {
  q: string[];
  //   inputValues: any;
  //   setInputValues: (type: any) => void;
  state: [any, (type: any) => void];
  id: string;
};
